// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"Loader_backdrop__hBCW8","loader":"Loader_loader__3LXMl"};